<template>
   <div class="auth-main">
      <div class="auth_div vivify fadeIn">
         
         <div class="card mb-0">
            <div class="auth_brand">
               <img :src="tema == 'dark' ? require('@/assets/images/sigap-logo-branco.png') : require('@/assets/images/sigap-logo.png')" width="200" class="d-inline-block align-top" alt="">                                             
            </div>
            <div class="header">
               <p class="lead mt-0" v-if="recuperacao || primeiroAcesso">Informe o email cadastrado</p>
               <p class="lead mt-0" v-else>Faça login para continuar!</p>
            </div>
            <div class="body px-0 px-sm-3">
               <form class="form-auth-small">
                  <div class="form-group c_form_group">
                     <label>Email</label>
                     <input type="email" class="form-control" placeholder="Digite seu email" v-model="usuario">
                  </div>
                  <div class="form-group c_form_group" v-if="!recuperacao && !primeiroAcesso">
                     <label>Senha</label>
                     <input type="password" class="form-control" placeholder="Digite sua senha" v-model="senha" @keyup.enter="verificarLogin">
                  </div>
                  <div class="form-group clearfix" v-if="!recuperacao && !primeiroAcesso">
                     <label class="fancy-checkbox element-left m-0">
                        <input type="checkbox" v-model="manterConectado">
                        <span>Mantenha-me conectado</span>
                     </label>
                  </div>
                  <button type="button" class="btn btn-theme btn-lg btn-block" @click="resetPassword" v-if="recuperacao">ENVIAR</button>
                  <button type="button" class="btn btn-theme btn-lg btn-block" @click="verificarLogin" v-else>ENTRAR</button>
                  <div class="bottom">
                     <span class="helper-text d-inline m-b-10" v-if="!recuperacao">
                        <i class="far fa-envelope font-13 mr-1" v-if="!primeiroAcesso"></i>
                        <a href="javascript:;" @click="primeiroAcesso = false;" v-if="primeiroAcesso">Voltar</a>
                        <a href="javascript:;" @click="primeiroAcesso = true;" v-else> Primeiro acesso</a>
                     </span>
                     <span class="mx-2 mx-sm-3 text-secondary" v-if="!recuperacao && !primeiroAcesso">|</span>
                     <span class="helper-text d-inline m-b-10" v-if="!primeiroAcesso">
                        <i class="far fa-lock font-13 mr-1" v-if="!recuperacao"></i>
                        <a href="javascript:;" @click="recuperacao = false;" v-if="recuperacao">Voltar</a>
                        <a href="javascript:;" @click="recuperacao = true;" v-else> Esqueceu a senha?</a>
                     </span>
                     <!-- <span>Não tem uma conta? <a href="javascript:;">Registrar</a></span> -->
                  </div>
               </form>
            </div>
         </div>
      </div>
      <div class="animate_lines">
         <div class="line"></div>
         <div class="line"></div>
         <div class="line"></div>
         <div class="line"></div>
         <div class="line"></div>
         <div class="line"></div>
      </div>
    </div>
</template>

<script>

import Swal from 'sweetalert2'
import { mapState } from 'vuex'

export default {
	name: 'Login',
   data: function() {
		return {
			usuario: '',
         senha: '',
         manterConectado: false,
         recuperacao: false,
         primeiroAcesso: false
		}
	},
   computed: {
		... mapState({
         urlRest: state => state.urlRest,
         tema: state => state.tema
		})
	},
   methods: {
		verificarLogin : function () {
         if (this.usuario.trim().length > 0 && (this.senha.trim().length > 0 || this.primeiroAcesso)) {
            this.$store.dispatch('verificarCredenciais', {'usuario': this.usuario.trim(), 'senha': this.senha.trim(), 'manterConectado': this.manterConectado});
         }
		},
      resetPassword : function () {
         if (this.usuario.trim().length == 0) {
            this.$toast.fire({
               icon: 'error',
               title: 'Email inválido!'
            })

            return
         }

         let ref = this;
			this.$store.dispatch('alternarTelaCarregamento', true)

         this.$axios({
            method: 'post',
            url: this.urlRest +'usuarios/resetPassword',
				params: {
               email: this.usuario.trim()
            }
         }).then(function () {
            ref.recuperacao = false;

            Swal.fire({
               icon: 'success',
               title: 'Email de recuperação enviado!'
            })
         }).catch(function (error) {
            if (error.response != undefined) {
               ref.$toast.fire({
                  icon: 'error',
                  title: 'Erro: ' + error.response.status
               })
            } else {
               ref.$toast.fire({
                  icon: 'error',
                  title: error
               })
            }
         }).finally(() => {
            this.$store.dispatch('alternarTelaCarregamento', false)
         })
      }
	}
}

</script>

<style scoped>

.auth-main .helper-text {
   vertical-align: unset !important;
}

.auth-main .card {
   box-shadow: 0 2px 15px rgba(0, 0, 0, 0.233);
   border-radius: 8px;
   border: 1px solid rgba(255, 255, 255, 0.1);
   padding: 20px;
}

.auth_brand{
   margin-bottom: 0px !important;
   /* margin-top: 20px !important; */
}

.btn-theme {
   background-color: var(--primary-color) !important;
   color: white !important;
}

</style>